module.exports = __webpack_public_path__ + "img/minus-icon.23c2f3ed.svg";